import React from 'react';

const AgreementsForeignExchangeRiskNotice = () => (
  <div name="foreignExchangeRiskNotice" className="row">
    <div className="col col-xs-12">
      <p>
        <strong>Foreign Exchange Risk Notice</strong>
        <br />
        As your account will be denominated in USD, you will be subject to
        currency risk relative to EUR. Fluctuations in the USD/EUR exchange
        rate may impact the value of your account when measured in EUR, regardless
        of the underlying investment performance.
      </p>
    </div>
  </div>
);

export default AgreementsForeignExchangeRiskNotice;
